import { Avatar } from "@/frontend/shared/ui/Avatar/Avatar";
import { Tag } from "@/frontend/shared/ui/Tag";
import styles from "./InvestorsCell.module.scss";
import { TCompany } from "@/frontend/pages/DashboardPage/const/const";

export function InvestorsCell({ field }: { field: TCompany["harmonicInvestors"] }) {
  return (
    <div className={styles.container}>
      <div className={styles.personsContainer}>
        {field?.slice(0, 2)?.map(({ harmonicInvestor: { name } }, index) => (
          <div key={index} className={styles.person}>
            <Avatar name={name} nameClassName={styles.name} />
            {index === 1 && field.length > 2 && <Tag size="small">+{`${field.length - 2}`}</Tag>}
          </div>
        ))}
      </div>
    </div>
  );
}
